module.exports = __webpack_public_path__ + "img/git-pull-request.5d0a81a5.png";